module.exports = __webpack_public_path__ + "assets/fontawesome-webfont.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.1
 ** module id = 117
 ** module chunks = 0
 **/